import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostUpdateStatus = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST__STATUS_UPDATE
            });
            dispatch(Action.SetGetSearchList({
                search: '',
                page: 1,
                rowsPerPage: 25
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateStatus as SetPostUpdateStatus
}